export default function formatVatCode(vatCode) {
  switch (vatCode) {
    case 'P23':
      return '23%';
    case 'P8':
      return '8%';
    case 'P5':
      return '5%';
    case 'P0':
      return '0%';
    case 'ZW':
      return 'ZW';
    case 'Unknown':
    default:
      return '?';
  }
}

export const vatCodeOptions = [
  { value: null, text: '-' },
  { value: 'P23', text: '23%' },
  { value: 'P8', text: '8%' },
  { value: 'P5', text: '5%' },
  { value: 'P0', text: '0%' },
  { value: 'ZW', text: 'ZW' },
];
